import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentIssued extends Layout {
    panelA: Panel;
    panelB: Panel;
    panelC: Panel;
    panelD: Panel;
    panelF: Panel;
    panelMain: Panel;
    sourceEquipmentIssued: DataSource;
    textboxComments: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxEquipmentValue: Textbox;
    textboxExpirationDate: Textbox;
    textboxIssuedDate: Textbox;
    textboxIssuedUserId: Textbox;
    textboxLocationId: Textbox;
    textboxMemo: Textbox;
    textboxQuantity: Textbox;
    textboxReceivedUserId: Textbox;
    textboxReturnedDate: Textbox;
    textboxStatus: Textbox;
}
